import React from "react";
import PropertyEvaluation from "../features/property/component/PropertyEvaluation";
import Footer from "./Footer";

function PropertyEvaluationPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <PropertyEvaluation></PropertyEvaluation>
      <Footer />
    </div>
  );
}

export default PropertyEvaluationPage;
